export default __webpack_public_path__ + "static/dummyFour-2680424b7f8983a6bbbe5729d56e2bf0.png";